'use strict';

import { waitForDependencies} from "../_imports/utils/utils.common";
import { debouncer } from '../../utils/utils'
import Cookies from 'js-cookie';
import acceptedCookiePolicy from '../../components/onetrust/cookiePolicy';


const initMobileCompactNavBanner = () => {
    if (window.innerWidth <= 1024) {
        unhideMobileBanner();
    } 

    window.addEventListener('resize', debouncer(() => {
        unhideMobileBanner();
    }, 250));

    const compactNavBannerContainer = document.querySelector('.compact-nav-banner-container.banner-mobile');

    if(compactNavBannerContainer) {
        const compactNavBannerHref = compactNavBannerContainer.querySelector('[am-compact-nav-banner] .compact-nav-banner-href');
        
        if(compactNavBannerHref) {
            initCompactNavBanner(compactNavBannerHref, 'mobile');
        }

        const compactNavBannerCloseButton = compactNavBannerContainer.querySelector('#compact-nav-banner-close');
        if (compactNavBannerCloseButton) {
            compactNavBannerCloseButton.addEventListener('click', () => closeCompatNavBanner(compactNavBannerContainer));
        }
    }
}

const initDesktopCompactNavBanner = () => {
    const compactNavBanner = document.querySelector('.compact-nav-banner-container.banner-in-nav [am-compact-nav-banner] .compact-nav-banner-href');

    if(compactNavBanner) {
        initCompactNavBanner(compactNavBanner, 'desktop');
    }
}

const initCompactNavBanner = (compactNavBanner) => {
    const contentContainer = compactNavBanner.querySelector('.compact-nav-banner-content');

    if(contentContainer) {
        checkOverflow(contentContainer);

        window.addEventListener('resize', debouncer(() => {
            checkOverflow(contentContainer);
        }, 250));
    }
}

const unhideMobileBanner = () => {
    if (window.innerWidth <= 1024) {
        const cnb = document.querySelector('.compact-nav-banner-container.banner-mobile');
        if (cnb) {
            cnb.removeAttribute('style');
        }
    }
}

const checkOverflow = (contentContainer) => {
    if (contentContainer.scrollWidth > contentContainer.offsetWidth) { 
        contentContainer.classList.add('is-overflow-text');
    }else {
        contentContainer.classList.remove('is-overflow-text');
    }
}


const closeCompatNavBanner = (compactNavBannerContainer) => {
    const compactNavBannerHeight = compactNavBannerContainer.getBoundingClientRect().height;
    
    compactNavBannerContainer.style.marginTop = `-${compactNavBannerHeight}px`;

    const styles = getComputedStyle(document.documentElement);
    const mobileHeight = styles.getPropertyValue('--compact-nav-banner-mobile-height');
    const currentHeaderHeight = parseInt(styles.getPropertyValue('--header-height').replace('px', ''));
    
    if (mobileHeight && currentHeaderHeight) {
        const mobileHeightValue = parseInt(mobileHeight.replace('px', ''));
        const newHeaderHeight = currentHeaderHeight - mobileHeightValue;
        document.documentElement.style.setProperty('--header-height', `${newHeaderHeight}px`);
        document.documentElement.style.setProperty('--compact-nav-banner-mobile-height', `0px`);
    }

    document.documentElement.classList.remove('compact-nav-banner-mobile-is-visible');

    setTimeout(() => {
        compactNavBannerContainer.remove();
    }, 700);

    const compactNavBannerElement = compactNavBannerContainer.querySelector('[am-compact-nav-banner]');
    const compactNavBannerCookieName = getCookieName(compactNavBannerElement);
    if (compactNavBannerCookieName) {
        setCookieValue(compactNavBannerCookieName, () => 'dismiss');
    }
};

const setCookieValue = (compactNavBannerCookieName, cookieValue) => {
    acceptedCookiePolicy({
        ifFunctionalCookies: () => {
            const compactNavBannerCookieValue = Cookies.get(compactNavBannerCookieName);
            Cookies.set(compactNavBannerCookieName, cookieValue(compactNavBannerCookieValue));
        }
    });
};

const getCookieName = compactNavBannerElement => {
    const compactNavBannerId = compactNavBannerElement.dataset.compactNavBannerId;
    return `compactNavBanner_${compactNavBannerId}`;
};

waitForDependencies(() => {
    initMobileCompactNavBanner();
    initDesktopCompactNavBanner();
});